import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_green-properties-crt/artifacts/4twghzfk_LOGO%20GREEHOUSE-def.pdf%20%282%29.png";

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Chi Siamo', path: '/about' },
  { name: 'Annunci', path: '/properties' },
  { name: 'Servizi', path: '/services' },
  { name: 'Vendi Casa', path: '/sell' },
  { name: 'Contatti', path: '/contact' },
];

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;
  const showTransparent = isHomePage && !isScrolled;

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        showTransparent ? 'bg-transparent' : 'bg-white/95 backdrop-blur-xl shadow-lg border-b border-border/50'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img
              src={LOGO_URL}
              alt="Green House"
              className={`h-16 w-auto transition-all duration-300 ${showTransparent ? 'brightness-0 invert' : ''}`}
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
                className={`font-sans text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-primary'
                    : showTransparent
                    ? 'text-white hover:text-accent'
                    : 'text-text-main hover:text-primary'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:+3908231848006"
              className="flex items-center space-x-2 bg-primary text-white px-5 py-2.5 rounded-md font-sans text-sm font-medium btn-primary"
              data-testid="call-button"
            >
              <Phone size={16} />
              <span>Chiamaci</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? (
              <X size={24} className={showTransparent ? 'text-white' : 'text-text-main'} />
            ) : (
              <Menu size={24} className={showTransparent ? 'text-white' : 'text-text-main'} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-xl" data-testid="mobile-menu">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block font-sans text-base font-medium py-2 ${
                  isActive(link.path) ? 'text-primary' : 'text-text-main hover:text-primary'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:+3908231848006"
              className="flex items-center justify-center space-x-2 bg-primary text-white px-5 py-3 rounded-md font-sans text-sm font-medium mt-4"
            >
              <Phone size={16} />
              <span>Chiamaci</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
